import { DataBean } from "../DataBean";

export class WelfareEntityType extends DataBean {

    public async getWelfareEntityTypeCatalog(type: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getWelfareEntityTypeCatalog_Number", [type]);
    }

    public async deleteWelfareEntityType(idWelfareEntityType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteWelfareEntityType_Number", [idWelfareEntityType]);
    }

    public async updateWelfareEntityType(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.WelfareEntityType_updateWelfareEntityType_admin.WelfareEntityType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "admin.WelfareEntityType"
            }
        ]);
    }

}
